import { clampFraction, withGap } from "@demo/components/ResizableSplit";
import { FOOTER_LABEL_WIDTH, PANEL_DEFAULTS, PANEL_MINIMUMS } from "@demo/libs/panel-layout";

export const COLUMN_GAP = 16;

/**
 * The default prompt-column share for a row `total` pixels wide, matching `DEFAULT_COLUMN_WIDTH`: the
 * larger of the footer's label width and `PANEL_DEFAULTS.horizontal` of the row, within the panes'
 * minimums. A row too narrow for the labels gets the widest prompt column the output pane's minimum
 * allows, and the footer collapses to icons.
 */
export const defaultColumnFraction = (total: number): number =>
  clampFraction(
    Math.max(FOOTER_LABEL_WIDTH / total, PANEL_DEFAULTS.horizontal),
    total,
    PANEL_MINIMUMS.promptPane,
    withGap(PANEL_MINIMUMS.outputPane, total, COLUMN_GAP),
  );
